import pubsub from 'sweet-pubsub';
import { writable } from 'svelte/store';
let state = {
    isLoggedIn: false,
    pubKey: '',
    accessToken: '',
    user: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        id: '',
        personal_email: ''
    },
    avatar: "",
    mode: ""
};
let auth = () => {
    const { subscribe, set, update } = writable(JSON.parse(localStorage.getItem('auth')) || state);
    subscribe((value) => {
        localStorage.setItem('auth', JSON.stringify(value));
    });
    return {
        subscribe,
        login: (token) => {
            return update((store) => (Object.assign(Object.assign({}, store), { isLoggedIn: true, accessToken: token })));
        },
        setPubKey: (token) => {
            return update((store) => (Object.assign(Object.assign({}, store), { isLoggedIn: true, pubKey: token })));
        },
        setAccessToken: (token) => {
            return update((store) => (Object.assign(Object.assign({}, store), { isLoggedIn: true, accessToken: token })));
        },
        setMode: (mode) => {
            return update((store) => (Object.assign(Object.assign({}, store), { mode })));
        },
        logout: () => {
            return set(state);
        },
        refresh: (token) => update((store) => (Object.assign(Object.assign({}, store), { accessToken: token }))),
        setUser: (user) => {
            pubsub.emit("user_store_updated", user);
            return update((store) => (Object.assign(Object.assign({}, store), { user: Object.assign(Object.assign({}, store.user), user) })));
        },
        setMobile: (mobile) => {
            return update((store) => (Object.assign(Object.assign({}, store), { user: Object.assign(Object.assign({}, store.user), { mobile: mobile }) })));
        },
        setAvatar: avatar => update(s => (Object.assign(Object.assign({}, s), { avatar })))
    };
};
export default auth();
